import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { ConsumerType } from "../types/types";
import { CONSUMER_STORE } from "../constants/constant";
import { getConsumerInsuranceQuotes } from "services/api/questions";
import { useCartStore } from "./cart";

const initialConsumerState = {
  consumerCoveragePrices: undefined,
  consumerCoverageError: false,
  consumerCoverageErrorCode: undefined,
};

export const useConsumerStore = create(
  devtools(
    persist<ConsumerType>(
      (set) => ({
        ...initialConsumerState,
        setConsumerCoveragePrices: async (productId: string) => {
          try {
            set(() => ({
              consumerCoverageError: false,
              consumerCoverageErrorCode: undefined,
            }));
            const { coverages, extra_coverages, allianz_consumer, clause } =
              await getConsumerInsuranceQuotes(productId);
            set(() => ({
              consumerCoveragePrices: {
                ...(coverages?.options || extra_coverages
                  ? {
                      car_product: {
                        ...(coverages?.options &&
                          Object.fromEntries(
                            Object.entries(coverages.options).map(
                              ([key, value]: [string, any]) => [
                                key,
                                value.price,
                              ]
                            )
                          )),
                        ...(extra_coverages &&
                          Object.fromEntries(
                            Object.entries(extra_coverages).map(
                              ([_, value]: [string, any]) => [
                                value.id,
                                value.price,
                              ]
                            )
                          )),
                      },
                    }
                  : {}),
                ...(allianz_consumer && {
                  consumer_product: allianz_consumer,
                }),
              },
              ...(clause && {
                consumerCoverageClause: clause,
              }),
            }));
          } catch (err: any) {
            if (err.failed) {
              set(() => ({
                consumerCoverageError: true,
                consumerCoverageErrorCode: err.code,
              }));
            }
            console.error(err);
            throw err;
          } finally {
            const { getCartItemList } = useCartStore.getState();
            await getCartItemList();
          }
        },
        clearConsumer: () => {
          set(() => initialConsumerState);
        },
      }),
      {
        name: CONSUMER_STORE,
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
